<template>
    <Head title="Register e-mail" />
    <RegisterLayout :showLogo="true" title="Faça Parte">
        <article class="xl:max-w-[352px] mx-auto">
            <div class="sm:px-5 xl:max-w-full">
                <p class="py-2"> Insira seu email abaixo:</p>

                <form @submit.prevent="submit">
                    <ul class="grid gap-5 pt-4">
                        <li>
                            <label class="mb-1 mr-5 flex font-semibold"> Email </label>
                            <Input placeholder="Exemplo: joao@email.com" type="email" required v-model="form.email" :state="state" />
                        </li>

                        <div v-if="$page.props.flash.error" class="flashError text-[10px] text-error">
                            {{ $page.props.flash.error }}
                        </div>

                        <button
                            @click.prevent="submit()"
                            class="
                                w-full
                                grid
                                justify-items-center
                                items-center
                                text-primary
                                font-semibold
                                border-primary border
                                rounded
                                hover:bg-yellow hover:border-transparent
                                p-1.5
                                sm:mt-6
                            "
                        >
                            Acessar
                        </button>
                    </ul>
                </form>
            </div>
        </article>
        <ValidationErrors :errors="errors" />
    </RegisterLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";
import RegisterLayout from "@/Layouts/Register.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Input,
    Label,
    ValidationErrors,
    Head,
    Link,
    RegisterLayout,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: "",
      }),
      errors: [],
      state: "default",
    };
  },

  methods: {
    submit() {
        // return alert('oi');
      this.errors = [];
    //   if (this.form.email == this.form.email) {
    //     this.errors.push("Email já cadastrado.");
    //     this.state = "error";
    //   } else {
        // this.state = "success";
        // console.log(this.form);
        sessionStorage.setItem("email", this.form.email);
        this.$inertia.post("/register", this.form);
    //   }
    },
  },
};
</script>
